"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../constants");
var _icons = require("../icons");
var _colors = require("../../birch/colors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BIRCH_FLAVOR_TO_STYLES = {
  warning: {
    backgroundColor: _colors.FullPalette.YELLOW_E25,
    borderColor: _colors.FullPalette.YELLOW_E25,
    iconColor: _colors.FullPalette.YELLOW_700
  },
  error: {
    backgroundColor: _colors.FullPalette.POPPY_E25,
    borderColor: _colors.FullPalette.POPPY_E25,
    iconColor: _colors.FullPalette.POPPY_700
  },
  success: {
    backgroundColor: _colors.FullPalette.GREEN_E25,
    borderColor: _colors.FullPalette.GREEN_E25,
    iconColor: _colors.FullPalette.GREEN_700
  },
  neutral: {
    backgroundColor: _colors.FullPalette.IRIS_E25,
    borderColor: _colors.FullPalette.IRIS_E25,
    iconColor: _colors.FullPalette.IRIS_700
  }
};
var Callout = function Callout(props) {
  var Icon = props.icon;
  return /*#__PURE__*/React.createElement(Container, {
    flavor: props.flavor
  }, Icon !== null && Icon !== undefined ? /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(Icon, {
    color: BIRCH_FLAVOR_TO_STYLES[props.flavor].iconColor,
    width: 20,
    height: 20
  })) : null, /*#__PURE__*/React.createElement(MainContent, null, props.title && /*#__PURE__*/React.createElement(Title, null, props.title), /*#__PURE__*/React.createElement(Body, null, props.children)), props.rightComponent && /*#__PURE__*/React.createElement(RightComponent, null, props.rightComponent), props.onDismiss && /*#__PURE__*/React.createElement(StyledXIcon, {
    onClick: props.onDismiss
  }));
};
var _default = exports["default"] = Callout;
var Container = _styledComponents["default"].div.withConfig({
  displayName: "callout__Container"
})(["background-color:", ";border:solid 1px ", ";padding:15px 25px;font-size:14px;border-radius:5px;margin-bottom:15px;display:flex;align-items:flex-start;"], function (props) {
  return BIRCH_FLAVOR_TO_STYLES[props.flavor].backgroundColor;
}, function (props) {
  return BIRCH_FLAVOR_TO_STYLES[props.flavor].borderColor;
});
var MainContent = _styledComponents["default"].div.withConfig({
  displayName: "callout__MainContent"
})(["flex:1;"]);
var Title = _styledComponents["default"].div.withConfig({
  displayName: "callout__Title"
})(["font-size:14px;font-weight:", ";"], _constants.fontWeight.heavy);
var Body = _styledComponents["default"].div.withConfig({
  displayName: "callout__Body"
})(["color:", ";font-weight:normal;"], _constants.colors.darkestGrey);
var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "callout__IconContainer"
})(["margin-right:8px;height:20px;"]);
var RightComponent = _styledComponents["default"].div.withConfig({
  displayName: "callout__RightComponent"
})(["margin-left:24px;align-self:center;"]);
var StyledXIcon = (0, _styledComponents["default"])(_icons.XIcon).withConfig({
  displayName: "callout__StyledXIcon"
})(["margin-left:16px;"]);